import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({

  state: {
    logged: false,
    token: '',
    accountID: '',
    user: '',
    secret: '',
    loading: true
  },

  getters: {
    logged: state => state.logged,
    token: state => state.token,
    accountID: state => state.accountID,
    user: state => state.user,
    secret: state => state.secret
  },

  mutations: {
    updateLoadingState(state, isLoading) {
      state.loading = isLoading
    },
    SET_TOKEN(state, token) {
      state.token = token,
        state.logged = true
    },
    SET_ACCOUNT_ID(state, id) {
      state.accountID = id
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_API_SECRET(state, id) {
      state.secret = id
    },
  },

  actions: {

  },
  plugins: [createPersistedState()]
});
export default store;